import React from 'react';
import { Steps, Breadcrumb, Layout, notification, Modal } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, compose, withApollo } from 'react-apollo';

import Loading from '../../common/Loading';

import FormAtencion from '../formularios/FormAtencion';
import insertAtencion from '../../../graphql/mutations/tramites/insertAtencion.graphql';
import BuscarYCrearPersona from '../../procesos/BuscarYCrearPersona';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;
const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(insertAtencion, {
    name: 'insertAtencion',
  }),
  graphql(getUsuario)
)
class CrearAtencion extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
  };

  componentDidMount() {
    let yo = this;
    confirm({
      title: 'Quiere cargar una persona para esta atencion?',
      content:
        'Si elige la opcion NO, solo se cargaran los datos propios de la atencion',
      okText: 'Si',
      okType: 'primary',
      cancelText: 'No',
      onOk() {},
      onCancel() {
        // console.log('Cancel');
        yo.siguientePaso();
      },
    });
  }

  guardarPersona = persona => {
    this.setState(
      {
        ...this.state,
        persona: {
          ...this.state.persona,
          ...persona,
        },
      },
      () => {
        this.siguientePaso();
      }
    );
  };

  guardarAtencion = datos => {
    if (this.state.persona._id && !this.state.guardado) {
      let data = {
        ...datos,
        fecha: datos.fecha.toDate(),
        idPersona: this.state.persona._id,
        idOrganismo: this.props.data.getUsuario.organismo._id,
        idCreador: this.props.data.getUsuario._id,
      };

      this.props
        .insertAtencion({
          variables: { atencion: data },
        })
        // eslint-disable-next-line no-unused-vars
        .then(respuestaAtencion => {
          notification.success({
            message: 'Nueva Atencion',
            description: 'Se ha registrado con exito los datos de la atencion',
          });

          this.setState(
            {
              ...this.state,
              guardado: true,
              atencion: data,
            },
            () => {
              this.props.history.push('/');
            }
          );
        })
        .catch(error => {
          console.log('Excepcion!!');
          console.log(error);
          errorService(error, {
            atencion: data,
          });
          Modal.error({
            title: 'Error en la creacion de la atencion',
            content:
              'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
          });
        });
    } else {
      if (!this.state.guardado && !this.state.persona._id) {
        //  Este caso es cuando crean una atencion sin persona.

        // console.log("ATENCION SIN PERSONA !");
        let data = {
          ...datos,
          fecha: datos.fecha.toDate(),
          idOrganismo: this.props.data.getUsuario.organismo._id,
          idCreador: this.props.data.getUsuario._id,
        };
        this.props
          .insertAtencion({
            variables: { atencion: data },
          })
          // eslint-disable-next-line no-unused-vars
          .then(respuestaAtencion => {
            notification.success({
              message: 'Nueva Atencion',
              description:
                'Se ha registrado con exito los datos de la atencion',
            });

            this.setState(
              {
                ...this.state,
                guardado: true,
                atencion: data,
              },
              () => {
                this.props.history.push('/');
              }
            );
          })
          .catch(error => {
            console.log('Excepcion!!');
            console.log(error);
            errorService(error, {
              atencion: data,
            });
            Modal.error({
              title: 'Error en la creacion de la atencion',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      } else {
        //Caso donde ya existia la persona en la BD
        // console.log("Caso donde no debo crear a la atencion!");
      }
    }
  };

  onCancel = () => {
    this.setState({
      fase: 0,
    });
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const { Step } = Steps;
    let { step } = this.state;
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Atencion</Breadcrumb.Item>
          <Breadcrumb.Item>Nueva</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Nueva Atencion
          </h2>
          <br />
          <Steps className="stepsFormularios" current={step}>
            <Step title="Buscar Persona" />
            <Step title="Datos de la Atencion" />
          </Steps>
          <div style={estiloContent}>
            {step === 0 && (
              <BuscarYCrearPersona obtenerPersona={this.guardarPersona} />
            )}
            {step === 1 && <FormAtencion onSubmit={this.guardarAtencion} />}
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(CrearAtencion);
